import React, {ButtonHTMLAttributes, ForwardedRef} from 'react';

import cn from 'classnames';

import bem from 'client/services/bem';

import {AppButtonProps} from 'client/common/buttons/app-button/types';

import Icon from 'client/components/common/icon';
import LoadingSpinner from 'client/components/common/loading-spinner';

import './app-button.scss';

const b = bem('app-button');

const AppButton = React.forwardRef(function AppButton(props: AppButtonProps, ref: ForwardedRef<HTMLButtonElement>) {
  const {
    className = '',
    classNameIcon = '',
    submit = false,
    label = '',
    onClick,
    onDoubleClick,
    color = 'clients',
    nativeStyle = false,
    iconName = '',
    transparent = false,
    outline = false,
    disabled = false,
    link = false,
    rounded = false,
    size = 'default',
    fontSize = 'default',
    loading = false,
    iconConfig,
    asWrap = false,
    id = null,
    disabledOpacity,
    title,
    compact,
    ...buttonProps
  } = props;

  const type: ButtonHTMLAttributes<HTMLButtonElement>['type'] = submit ? 'submit' : 'button';

  const iconProps = asWrap
    ? iconConfig
    : {
        width: label ? 16 : 24,
        height: label ? 16 : 24,
        ...iconConfig,
      };

  return (
    <button
      type={type}
      id={id ?? undefined}
      ref={ref}
      className={cn(
        b({
          [color]: true,
          [size]: true,
          [`font-size-${fontSize}`]: true,
          ['disabled-opacity']: disabledOpacity,
          'has-label': !!label,
          'has-icon': !!(iconName || iconConfig?.name),
          'as-wrap': asWrap,
          'not-as-wrap': !(nativeStyle || asWrap),
          transparent,
          outline,
          disabled,
          link,
          rounded,
          loading,
          compact,
        }),
        className,
      )}
      disabled={disabled}
      onClick={loading ? () => {} : onClick}
      onDoubleClick={loading ? () => {} : onDoubleClick}
      title={title?.toString()}
      {...buttonProps}
    >
      {(iconName || iconConfig?.name) && (
        <Icon name={iconName} className={cn(b('icon', {'has-label': !!label}), classNameIcon)} {...iconProps} />
      )}
      {label}
      {loading && (
        <div className={b('loader')}>
          <LoadingSpinner loading />
        </div>
      )}
    </button>
  );
});

export default AppButton;
